<template>
  <div>
    <!-- content -->
    <div class="content--block">
      <!-- jumbtron -->
      <div class="custom-content--header" style="background-image: url(/images/main-img.jpg);">
        <div class="custom-content--header-shade"></div>
        <div class="custom-content--header-content">
          <div class="custom-content--header-image-wrapper">
            <div
              class="custom-content--header-image"
              style="background-image: url(/images/main-img-mobile.jpg);"
            ></div>
          </div>
          <div class="custom-content--header-content-wrapper">
            <div class="custom-content--heading">
              <h1>Future of banking</h1>
            </div>
            <div class="custom-content--paragraph">
              <p>Develop banking applications together with us and build digital future</p>
            </div>
            <div class="custom-content--cta">
              <a
                class="custom-content--cta-button"
                href="javascript:void(0)"
                v-on:click="signupWindow"
              >
                <p>Start developing</p>
              </a>
            </div>
          </div>
        </div>
      </div>
      <!--/. jumbtron -->
      <!-- main head -->
      <div class="custom-content--header-min">
        <div class="custom-content--header-min-container">
          <h2 class="custom-content--header-min-heading">Getting started</h2>
        </div>
      </div>
      <!--/. main head -->
      <!-- sandbox -->
      <template v-for="(row, index) in pages">
        <template v-if="index % 2 == 0 && row.imageUrl">
          <!-- sandbox -->
          <div class="custom-content--block-image-left">
            <img class="custom-content--block-image-left-image" :src="row.imageUrl" alt>
            <div class="custom-content--block-image-left-content">
              <div class="custom-content--heading">
                <h3>{{ row.title }}</h3>
              </div>
              <div class="custom-content--list" v-html="shortNew(row.publishedContent)"></div>
              <div class="custom-content--block-cta-container">
                <div class="custom-content--cta">
                  <router-link
                    v-if="longNew(row.publishedContent)"
                    class="custom-content--cta-button"
                    :to="{ path: '/p/pages/' + row.permalink}"
                  >
                    <p>
                      More
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        class
                      >
                        <path d="M6 0L4.94 1.06l4.19 4.19H0v1.5h9.13l-4.19 4.19L6 12l6-6-6-6"></path>
                      </svg>
                    </p>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <!--/. sanbox -->
        </template>
        <template v-if="index % 2 == 1 && row.imageUrl">
          <!-- ttp -->
          <div class="custom-content--block-image-right">
            <div class="custom-content--block-image-right-content">
              <div class="custom-content--heading">
                <h3>{{ row.title }}</h3>
              </div>
              <div class="custom-content--list" v-html="shortNew(row.publishedContent)"></div>
              <div class="custom-content--block-cta-container">
                <div class="custom-content--cta">
                  <router-link
                    v-if="longNew(row.publishedContent)"
                    class="custom-content--cta-button"
                    :to="{ path: '/p/pages/' + row.permalink}"
                  >
                    <p>
                      More
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="12"
                        height="12"
                        viewBox="0 0 12 12"
                        class
                      >
                        <path d="M6 0L4.94 1.06l4.19 4.19H0v1.5h9.13l-4.19 4.19L6 12l6-6-6-6"></path>
                      </svg>
                    </p>
                  </router-link>
                </div>
              </div>
            </div>
            <img class="custom-content--block-image-right-image" :src="row.imageUrl" alt>
          </div>
          <!--/. ttp -->
        </template>
        <template v-if="!row.imageUrl">
          <div class="content--articles">
            <div class="content--articles-main-block">
              <h1 class="content--articles-heading">{{ row.title }}</h1>
            </div>
            <div class="article--recommended article--recommended---full-list" v-html="shortNew(row.publishedContent)"></div>
          </div>
        </template>
      </template>
      <!--/. sanbox -->
    </div>
    <!--/. content -->
  </div>
</template>
<script>
import * as api from "../modules/api.js";
var me;
export default {
  name: "home",
  data: function() {
    return {
      pages: [],
      confirmToken: null,
      resetToken: null
    };
  },
  mounted() {
    me = this;
    me.confirmToken = me.$route.query.token;
    me.resetToken = me.$route.query.resettoken;

    api.request(api.pagesList).then(function(pages) {
      me.pages = pages;
    });

    if (me.resetToken) {
      me.$store.commit("UpdateResetToken", me.resetToken);
      $("#first").fadeOut("fast", function() {
        $("#fourth").fadeIn("fast");
        $("#myModal").modal("show");
      });
    }

    if (me.confirmToken) {
      api.request(api.confirm, { token: me.confirmToken }).then(
        function(response) {
          me.$store.dispatch("notify", {
            type: "success",
            message: "Email was confirmed. Now you can login"
          });
          $("#fourth").fadeOut("fast");
          $("#third").fadeOut("fast", function() {
            $("#first").fadeIn("fast");
          });
          $("#myModal").modal("show");
        },
        function(error) {
          var data = error.response.data;
          me.$store.dispatch("notify", {
            type: "warning",
            message: data.message
          });
        }
      );
    }
  },
  methods: {
    signupWindow: function() {
      this.$store.dispatch("signupWindow");
    },
    shortNew: function(newsContent) {
      return newsContent.split("<p>&lt;!--more--&gt;</p>")[0];
    },
    longNew: function(newsContent) {
      return newsContent.split("<p>&lt;!--more--&gt;</p>")[1];
    }
  }
};
</script>
<style>
.html-content p:first-child {
  display: inline;
}
</style>